import type { CognitoryActivitySummaryView } from "../api/cognitoryQuestionAnswerTraceOwnerReadRebuild";

export function shouldApplyActivityFetchResult(input: {
  requestGeneration: number;
  activeGeneration: number;
  requestCognitoryId: string;
  activeCognitoryId: string;
}): boolean {
  if (input.requestCognitoryId !== input.activeCognitoryId) {
    return false;
  }
  return input.requestGeneration === input.activeGeneration;
}

export function appendActivitySummaries(input: {
  current: CognitoryActivitySummaryView[];
  incoming: CognitoryActivitySummaryView[];
}): CognitoryActivitySummaryView[] {
  const seen = new Set(input.current.map(item => item.traceRequestId));
  const merged = [...input.current];
  for (const item of input.incoming) {
    if (seen.has(item.traceRequestId)) {
      continue;
    }
    seen.add(item.traceRequestId);
    merged.push(item);
  }
  return merged;
}

export function canStartActivityLoadMore(input: {
  loadingMore: boolean;
  nextCursor: string | null;
}): boolean {
  return !input.loadingMore && Boolean(input.nextCursor);
}
